import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import DocumentTemplateUtils from 'services/DocumentTemplateUtils';
import { isEditableBy } from '../SelectedElementEditPanel/EditableByRolesEnum';
import CPPUtils from 'services/CPPUtils';
import PlaceholderField from 'components/HealthRecords/Documents/DocumentTemplate/Utils/PlaceholderField';

const DocumentTemplateTextfield = ({
  field,
  editMode,
  pageWidth,
  pageHeight,
  fieldValues,
  selectedEditElement,
  selectEditElement,
  onChange,
  updateField,
  handleStop,
  prefill,
  className = '',
  toggleQuickPlaceholder,
  role,
  macroData,
}) => {
  let isEditable = editMode || isEditableBy(field?.editable_by, role);

  let {
    x_percent,
    y_percent,
    w_percent,
    h_percent,
    id,
    font_size,
    letter_spacing,
    background,
    placeholder,
    disabled,
  } = field;

  let style = DocumentTemplateUtils.parseStyle(field.style || {}) || {};

  let value = '';

  if (fieldValues[id] !== undefined) value = fieldValues[id];
  else if (prefill && prefill[id] !== undefined) value = prefill[id];
  else if (placeholder && prefill && prefill[placeholder]) value = prefill[placeholder];

  let macroResult = CPPUtils.checkMacro(value, macroData);

  useEffect(() => {
    if (macroResult && macroResult !== value) {
      const event = {
        target: {
          name: id,
          value: macroResult,
        },
      };
      onChange(event);
    }
  }, [macroResult, value, id]);

  if (!value && editMode) value = 'Example Text';
  className = 'template-input ' + className;

  if (letter_spacing) {
    style.paddingLeft = '3px';
    style.fontFamily = 'monospace, monospace';
    style.letterSpacing = letter_spacing + 'px';
  }
  if (font_size) style.fontSize = `${font_size}px`;
  style.background = background || 'transparent';

  const isSelected = selectedEditElement === id;

  let wrapperClassName = 'input-wrapper';
  if (isEditable) wrapperClassName += ' editable';
  if (isSelected) wrapperClassName += ' edit';

  let textField = (
    <div className={wrapperClassName}>
      {isSelected && toggleQuickPlaceholder && (
        <div className="top-options">
          <PlaceholderField updateField={updateField} element={field} />
        </div>
      )}
      <input
        type="text"
        className={`template-field ${className}`}
        data-field-id={id}
        name={id}
        value={value}
        key={id}
        disabled={disabled === 'true' || !isEditable}
        onChange={onChange}
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          border: 'none',
          background: 'none',
          boxSizing: 'border-box',
          fontFamily: 'Arial',
          fontSize: '14px',
          ...style,
        }}
      />
    </div>
  );

  return DocumentTemplateUtils.getRndElement(
    id,
    textField,
    {
      x: DocumentTemplateUtils.percentToPixel(x_percent, pageWidth),
      y: DocumentTemplateUtils.percentToPixel(y_percent, pageHeight),
      w: DocumentTemplateUtils.percentToPixel(w_percent, pageWidth),
      h: DocumentTemplateUtils.percentToPixel(h_percent, pageHeight),
    },
    editMode,
    selectEditElement,
    handleStop,
    updateField,
    { zIndex: isSelected ? 1 : 0 },
  );
};

DocumentTemplateTextfield.propTypes = {
  field: PropTypes.object,
  selectedEditElement: PropTypes.string,
  editMode: PropTypes.bool,
  prefill: PropTypes.object,
  fieldValues: PropTypes.object,
  pageWidth: PropTypes.number,
  pageHeight: PropTypes.number,
  selectEditElement: PropTypes.func,
  handleStop: PropTypes.func,
  onChange: PropTypes.func,
  updateField: PropTypes.func,
};

export default DocumentTemplateTextfield;
